let _ = t => t,
  _t;
import { createGlobalStyle, css } from 'styled-components';
const loadingSuccessState = css(["background-color:", " !important;svg{circle[stroke]{stroke:", " !important;}&[data-icon-name='Success']{fill:", " !important;}}"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['fill-brand-default'], ({
  theme
}) => theme.color['fill-brand-default']);
const primaryButtonBase = css(["background-color:", " !important;border-color:", " !important;&:hover{background-color:", " !important;border-color:", " !important;}"], ({
  theme
}) => theme.color['fill-brand-default'], ({
  theme
}) => theme.color['border-brand-default'], ({
  theme
}) => theme.color['fill-brand-hover'], ({
  theme
}) => theme.color['fill-brand-hover']);
const secondaryButtonBase = css(["background-color:", " !important;border-color:", " !important;color:", " !important;&:hover{background-color:", " !important;border-color:", " !important;color:", " !important;svg[data-icon-name]{fill:", " !important;}}"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['border-brand-default'], ({
  theme
}) => theme.color['border-brand-default'], ({
  theme
}) => theme.color['fill-accent-light-orange-subtle-alt'], ({
  theme
}) => theme.color['fill-brand-hover'], ({
  theme
}) => theme.color['fill-brand-hover'], ({
  theme
}) => theme.color['fill-brand-hover']);
export const GlobalWebBrandingStyles = createGlobalStyle(_t || (_t = _`
  a,
  button {
    &[data-button-use='primary']:not([aria-disabled='true']) {
      ${0}

      &[data-loading-state='success'],
      &[data-loading-state='loading'] {
        ${0}
      }
    }

    &[data-button-use='secondary']:not([aria-disabled='true']) {
      ${0}

      &[data-loading-state='success'],
      &[data-loading-state='loading'] {
        ${0}
      }
    }
  }
`), primaryButtonBase, loadingSuccessState, secondaryButtonBase, loadingSuccessState);